export const ALL_LOCATIONS_OPTION = {
  location_id: 'ALL_LOCATIONS',
  location_type: 'Agency',
  location_name: ' My Assigned Locations',
};

export const ERROR_ROW_OBJECT = {
  id: 'nodata',
  parentId: null,
  location_id: 'nodata',
  location_name: 'Error Occurred Loading Data',
  count: 0,
};

export const NO_RESULTS_OBJECT = {
  id: 'empty',
  parentId: null,
  location_id: 'empty',
  location_name: 'No Results Found',
  count: 0,
};
